import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { formatNumberWithCommas } from 'helper';
import _ from 'lodash';
import * as actions from '../action';
import * as c from '../constant';
import EditPropertyAppraisalModal from '../modals/EditPropertyAppraisalModal';

function PropertyAppraisalContainer({
  getList,
  appraisalList,
  applicationId,
  isLoading,
  getFloorArea,
  floorAreaList,
  showAppraisalData,
  appraisalInfo,
  applicationInfo
}) {

  const [formData, setFormData] = useState({});
  const setModal = useContext(ModalContext);

  const handleEdit = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <EditPropertyAppraisalModal
          buildingId={applicationId}
          dataInfo={appraisalInfo}
          floorAreaList={floorAreaList}
        />),
      title: 'Edit Property Appraisal',
      modalSize: 'modal-xl',
    });
  };

  const OnSetFormData = () => {
    if (appraisalList.length > 0 && +_.get(appraisalList, '0.attributes.rptax_building_application_id') === +applicationId) {
      setFormData({
        cost_of_additional_item_sub_total: _.get(appraisalList, '0.attributes.cost_of_additional_item_sub_total'),
        sub_total_adjustment: _.get(appraisalList, '0.attributes.sub_total_adjustment'),
        total_construction_cost: _.get(appraisalList, '0.attributes.total_construction_cost'),
        depreciation_rate: _.get(appraisalList, '0.attributes.depreciation_rate'),
        depreciation_cost: _.get(appraisalList, '0.attributes.depreciation_cost'),
        total_percent_depreciation: _.get(appraisalList, '0.attributes.total_percent_depreciation'),
        market_value: _.get(appraisalList, '0.attributes.market_value'),
      });
      showAppraisalData(applicationId, _.get(appraisalList, '0.id'));
    }
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getList(applicationId);
  }, []);

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getList(applicationId);
    getFloorArea(applicationId);

  }, [applicationId]);

  useEffect(() => {
    if (!_.isEmpty(appraisalList)) {
      OnSetFormData();
    }
  }, [appraisalList]);

  return (
    <div className="card-content-listing">
      <div className="card p-0 mr-2">
        {isLoading ? (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <>
            <div className="row d-flex align-items-center mt-2">
              <div className="col py-3 ml-2">
                <span className="title-color">Property Appraisal</span>
              </div>
              {[
                'PENDING',
                'FOR APPRAISAL AND ASSESSMENT',
                'TRANSFERRED',
                'FOR REASSESSMENT',
              ].indexOf(_.get(applicationInfo, 'attributes.status')) > -1 &&
                (
                  <div className="col py-0 m-0 d-flex">
                    <button
                      type="button"
                      onClick={handleEdit}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto mr-2"
                    >
                      <i className="fas fa-edit" /> Edit Property Appraisal
                    </button>
                  </div>
                )}
            </div>
            <div className="row my-3 mx-2">
              <table className="css-table table table-borderless table-sm table-striped table-hover">
                <thead className="table-header">
                  <tr>
                    <td className="font-weight-bold">Floor</td>
                    <td className="font-weight-bold">Actual Use</td>
                    <td className="font-weight-bold">Floor Area</td>
                    <td className="font-weight-bold">Market Value</td>
                    <td className="font-weight-bold">Remarks</td>
                  </tr>
                </thead>
                <tbody>
                  {_.isEmpty(floorAreaList) ? (
                    <tr className="w-100">
                      <td colSpan="5" className="text-center border-top p-4 text-muted">
                        This Section is Empty
                      </td>
                    </tr>
                  ) : (
                    floorAreaList.map(item => (
                      <tr key={item.id}>
                        <td className="history-color">{_.get(item, 'attributes.floor')}</td>
                        <td className="history-color">{_.get(item, 'attributes.actual_use') || ''}</td>
                        <td className="history-color">{_.get(item, 'attributes.area') || ''}</td>
                        <td className="history-color">PHP{' '}{formatNumberWithCommas(_.get(item, 'attributes.market_value') || 0)}</td>
                        <td className="history-color">{_.get(item, 'attributes.remarks') || ''}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <hr />
            <div className="col-12 mt-1">
              <span className="title-color">Breakdown of Costs</span>
            </div>
            <div className="row my-3 mx-2">
              <div className="d-flex">
                <table className="css-table table table-bordered table-sm mr-2 ml-2">
                  <tbody>
                    <tr>
                      <td className="text-dark" width="200">
                        Cost of Additional Items
                      </td>
                      <td width="150">
                        <span className="title-color">
                          PHP{' '}{_.get(formData, 'cost_of_additional_item_sub_total') || '0.00'}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="200">
                        Sub-Total Adjustment
                      </td>
                      <td width="150">
                        <span className="title-color">
                          PHP{' '}{_.get(formData, 'sub_total_adjustment')
                            ? parseFloat(
                              _.get(formData, 'sub_total_adjustment')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : '0.00'}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="200">
                        Total Construction Cost
                      </td>
                      <td width="150">
                        <span className="title-color">
                          PHP{' '}{_.get(formData, 'total_construction_cost') || '0.00'}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className="css-table table table-bordered table-sm">
                  <tbody>
                    <tr>
                      <td className="text-dark" width="200">
                        Depreciation Rate
                      </td>
                      <td width="150">
                        <span className="title-color">
                          {_.get(formData, 'depreciation_rate')
                            ? parseFloat(
                              _.get(formData, 'depreciation_rate')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : '0.00'} %
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="200">
                        Depreciation Cost
                      </td>
                      <td width="150">
                        <span className="title-color">
                          PHP{' '}{_.get(formData, 'depreciation_cost') || '0.00'}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="200">
                        Total % Depreciation Cost
                      </td>
                      <td width="150">
                        <span className="title-color">
                          PHP{' '}{_.get(formData, 'total_percent_depreciation')
                            ? parseFloat(
                              _.get(formData, 'total_percent_depreciation')
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : '0.00'}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-dark" width="200">
                        Market Value
                      </td>
                      <td width="150">
                        <span className="title-color">
                          PHP{' '}{_.get(formData, 'market_value') || '0.00'}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

PropertyAppraisalContainer.defaultProps = {
  applicationId: '',
  applicationInfo: {}
};

PropertyAppraisalContainer.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  appraisalList: PropTypes.instanceOf(Array).isRequired,
  applicationId: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  getFloorArea: PropTypes.instanceOf(Function).isRequired,
  floorAreaList: PropTypes.instanceOf(Array).isRequired,
  appraisalInfo: PropTypes.instanceOf(Object).isRequired,
  showAppraisalData: PropTypes.instanceOf(Function).isRequired,
  applicationInfo: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  appraisalList: _.get(api, `${c.GET_APPRAISAL_LIST}.list`) || [],
  floorAreaList: _.get(api, `${c.GET_FLOOR_AREA}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_APPRAISAL_LIST) > -1,
  appraisalInfo: _.get(api, `${c.SHOW_APPRAISAL_DATA}.item`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PropertyAppraisalContainer);
